/**
 * Second sign-in step for a user who already has an authenticator app:
 * enter its current code.
 */

import { useAuth } from '@shared/auth/AuthContext';
import { AUTH_BODY_CLASS, AUTH_HEADING_CLASS, AUTH_LINK_BUTTON_CLASS } from './authFormStyles';
import { TotpCodeForm } from './TotpCodeForm';

export function TotpChallengeStep() {
  const { verifyTotpChallenge, logout } = useAuth();

  return (
    <div className="w-full">
      <h2 className={AUTH_HEADING_CLASS}>Two-factor authentication</h2>
      <p className={AUTH_BODY_CLASS}>Enter the 6-digit code from your authenticator app.</p>

      <TotpCodeForm submitLabel="Verify" onSubmit={verifyTotpChallenge} />

      <p className="mb-3 mt-4 text-xs text-text-muted">
        Lost access to your authenticator app? An administrator can reset two-factor authentication
        for your account.
      </p>
      <button type="button" onClick={() => void logout()} className={AUTH_LINK_BUTTON_CLASS}>
        Sign out
      </button>
    </div>
  );
}
